import { Person } from "data/@types/Person";
import { create } from "zustand";
import { getLoggedInPersonApi } from "data/services/api/person";
import { ResetAction } from "data/@types/StoreUtils";

type State = {
  loading: boolean;
  data: Person | null;
  errorData: any;
};

const initialState: State = {
  loading: false,
  data: null,
  errorData: null,
};

const usePersonStore = create<State & ResetAction>((set) => ({
  ...initialState,
  reset: () => set(initialState),
}));

const getLoggedInPerson = async () => {
  usePersonStore.setState({ ...initialState, loading: true });
  try {
    const data = await getLoggedInPersonApi();
    usePersonStore.setState({ ...initialState, data });
  } catch (err) {
    console.error("Error in data fetch:", err);
    usePersonStore.setState({ ...initialState, errorData: err });
  }
};

export { usePersonStore, getLoggedInPerson };
